function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M149.989-800v-1.765h7.884a.345.345 0 0 0 .249-.113.345.345 0 0 0 .113-.249v-15.747a.345.345 0 0 0-.113-.249.345.345 0 0 0-.249-.113h-7.884V-820h7.884a2.053 2.053 0 0 1 1.509.618 2.053 2.053 0 0 1 .618 1.509v15.747a2.053 2.053 0 0 1-.618 1.509 2.053 2.053 0 0 1-1.509.618zm-1.6-4.977-1.222-1.276 2.864-2.864H140v-1.765h10.036l-2.864-2.864 1.222-1.276 5.022 5.022z",
    transform: "translate(-140 820)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.a59c16baef09cc8d12199418c2fab57d.svg";
export { ForwardRef as ReactComponent };